import { render, staticRenderFns } from "./requestlist.vue?vue&type=template&id=56019280"
import script from "./requestlist.vue?vue&type=script&lang=js"
export * from "./requestlist.vue?vue&type=script&lang=js"
import style0 from "./requestlist.vue?vue&type=style&index=0&id=56019280&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports